import InvitationsSection from './InvitationsSection';

export default InvitationsSection;
